declare namespace $ {

	type $mol_view__sub_bog_ui_app_toast_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_toast_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_toast_3 = $mol_type_enforce<
		ReturnType< $bog_ui_app_toast['add_info'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_toast_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_toast_5 = $mol_type_enforce<
		ReturnType< $bog_ui_app_toast['add_success'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_toast_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_toast_7 = $mol_type_enforce<
		ReturnType< $bog_ui_app_toast['add_warning'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_toast_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_toast_9 = $mol_type_enforce<
		ReturnType< $bog_ui_app_toast['add_error'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_toast_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_ui_app_toast_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_app_toast extends $mol_page {
		description( ): string
		Description( ): $mol_view
		buttons_title( ): string
		Buttons_title( ): $mol_view
		add_info( next?: any ): any
		info_label( ): string
		Info_button( ): $mol_button_minor
		add_success( next?: any ): any
		success_label( ): string
		Success_button( ): $mol_button_minor
		add_warning( next?: any ): any
		warning_label( ): string
		Warning_button( ): $mol_button_minor
		add_error( next?: any ): any
		error_label( ): string
		Error_button( ): $mol_button_minor
		Buttons( ): $mol_view
		Manager( ): $bog_ui_toast_manager
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=toast.view.tree.d.ts.map